export interface ContactFields {
  name: string
  email: string
  phone: string
  message: string
  consent: boolean
}

export type ContactErrors = Partial<Record<keyof ContactFields, string>>

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/
const PHONE_RE = /^\+?[\d\s()-]{9,}$/

export function validateContact(fields: ContactFields, requireMessage: boolean): ContactErrors {
  const errors: ContactErrors = {}
  if (fields.name.trim().length < 2) {
    errors.name = 'Zadajte meno a priezvisko.'
  }
  if (!fields.email.trim()) {
    errors.email = 'Zadajte e-mail.'
  } else if (!EMAIL_RE.test(fields.email.trim())) {
    errors.email = 'E-mail nemá správny formát (napr. meno@firma.sk).'
  }
  if (fields.phone.trim() && !PHONE_RE.test(fields.phone.trim())) {
    errors.phone = 'Telefón nemá správny formát (napr. +421 900 000 000).'
  }
  if (requireMessage && fields.message.trim().length < 10) {
    errors.message = 'Napíšte aspoň pár slov o vašom projekte (min. 10 znakov).'
  }
  if (!fields.consent) {
    errors.consent = 'Bez súhlasu so spracovaním údajov vás nemôžeme kontaktovať.'
  }
  return errors
}
